/* global module, require */
const OrbitControls = require('three-orbitcontrols'),
	THREE = require('three');

function Planner(config = {}) {
	var me = this;

	me.camera = new THREE.PerspectiveCamera(45, 1, 1, 10000);

	me.scene = new THREE.Scene();
	me.scene.background = new THREE.Color(0xf0f0f0);

	me.ambientLight = new THREE.AmbientLight(0x606060);
	me.scene.add(me.ambientLight);

	me.directionalLight = new THREE.DirectionalLight(0xffffff);
	me.directionalLight.position.set(1, 0.75, 0.5).normalize();
	me.scene.add(me.directionalLight);

	me.renderer = new THREE.WebGLRenderer({
		antialias: true,
		preserveDrawingBuffer: true,
	});
	me.renderer.setPixelRatio(window.devicePixelRatio);

	me.element = me.renderer.domElement;

	me.controls = new OrbitControls(me.camera, me.element);
	me.controls.enabled = true;
	me.controls.enableKeys = false;

	const target = config.cameraTarget;
	if (target) me.controls.target.set(target.x, target.y, target.z);

	const camera = config.camera || { x: 60, y: 60, z: 60 };
	me.camera.position.set(camera.x, camera.y, camera.z);
	me.controls.update();

	me.callbacks = {};
	me.styles = [];
	me.style = null;

	window.addEventListener('resize', this.resized.bind(this));
	this.resized();
}

Planner.prototype.changeStyle = function(style) {
	var old = this.style;
	if (old && old.disable) old.disable();

	this.style = style;

	if (style.enable) style.enable();
};

Planner.prototype.addStyle = function(Style, args) {
	var me = this;

	var style = new Style(me, args || {});
	me.styles.push(style);
	if (me.styles.length === 1) me.changeStyle(style);

	return me;
};

Planner.prototype.addToDom = function(parentOrNull) {
	var me = this;
	const parent = parentOrNull || document.body;

	me.renderer.setSize(parent.clientWidth, parent.clientHeight);

	me.parent = parent;
	me.parent.appendChild(me.element);
	me.resized();

	return me;
};

Planner.prototype.resized = function() {
	if (this.parent) {
		const { clientWidth, clientHeight } = this.parent;
		this.width = clientWidth;
		this.height = clientHeight;

		this.camera.aspect = clientWidth / clientHeight;
		this.camera.updateProjectionMatrix();
		this.renderer.setSize(clientWidth, clientHeight);
		this.render();
	}
};

Planner.prototype.render = function() {
	this.renderer.render(this.scene, this.camera);

	return this;
};

Planner.prototype.setCallback = function(name, fn) {
	this.callbacks[name] = fn;

	return this;
};

Planner.prototype.call = function(name, ...args) {
	if (this.callbacks[name]) return this.callbacks[name](...[this, ...args]);
};

module.exports = Planner;
